import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XMarkIcon } from '../icons/SalesIcons';
export function QualificationSection() {
  const forYou = ['Eres principiante total y quieres aprender desde cero con bases sólidas', 'Ya hiciste velas antes pero los resultados no son lo que esperabas', 'Quieres montar un negocio desde casa con algo que realmente disfrutas', 'Buscas un ingreso adicional flexible que se adapte a tu vida', 'Quieres hacer regalos únicos y personalizados que impresionen a todos', 'Necesitas un sistema completo, no tutoriales sueltos y confusos'];
  const notForYou = ['Buscas resultados sin esfuerzo ni dedicación', 'No estás dispuesta a seguir un proceso paso a paso', 'Prefieres seguir experimentando sola con tutoriales incompletos'];
  return <section className="bg-[#FDF8F4] py-16 md:py-24" data-id="element-366">
      <div className="max-w-6xl mx-auto px-4" data-id="element-367">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-368">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-white rounded-2xl shadow-xl border border-[#C4A882]/30 p-8" data-id="element-369">
            <h3 className="font-heading text-2xl text-[#5C4033] mb-6 flex items-center gap-3" data-id="element-370">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#C4A882] to-[#9B2335] flex items-center justify-center" data-id="element-371">
                <CheckIcon size={20} className="text-white" data-id="element-372" />
              </div>
              Esto Es Para Ti Si...
            </h3>
            <ul className="space-y-4" data-id="element-373">
              {forYou.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-374">
                  <CheckIcon size={20} className="text-[#9B2335] flex-shrink-0 mt-1" data-id="element-375" />
                  <span className="text-[#2D2926]" data-id="element-376">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-[#F5F0EB] rounded-2xl shadow-xl border border-[#D4A0A0]/30 p-8" data-id="element-377">
            <h3 className="font-heading text-2xl text-[#5C4033] mb-6 flex items-center gap-3" data-id="element-378">
              <div className="w-10 h-10 rounded-full bg-[#D4A0A0] flex items-center justify-center" data-id="element-379">
                <XMarkIcon size={20} className="text-white" data-id="element-380" />
              </div>
              Esto No Es Para Ti Si...
            </h3>
            <ul className="space-y-4" data-id="element-381">
              {notForYou.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-382">
                  <XMarkIcon size={20} className="text-[#9B2335]/50 flex-shrink-0 mt-1" data-id="element-383" />
                  <span className="text-[#5C4033]/70" data-id="element-384">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}